export const advertiserConstants = {
  SET_FIELD: 'SET_ADVERTISER_FIELD',
  RESET: 'RESET_ADVERTISER',
  SET_POLITICAL_ADV_STATUS: 'SET_POLITICAL_ADV_STATUS',
  SET_POLITICAL_ADVERTISER: 'SET_POLITICAL_ADVERTISER',
};
